/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    array, string, object, number, func, arrayOf, shape,
} from 'prop-types';
import GraphqlImoc from './Partials/GraphqlImoc/GraphqlImoc';
import GraphqlSubnav from './Partials/GraphqlSubnav/GraphqlSubnav';

const GraphqlCatHeaderContainer = ({
    categoryHeader, brand, samedayCutoff, totalCount, ssrDeviceType, featureFlags, setFacetsOptions, setFilterOptions, presentation_family, productFacets, imocHeightHandler,
}) => (
    <>
        {categoryHeader.length !== 0 ? categoryHeader.map((block) => {
            const blockKey = Object.keys(block)[0];
            const blockObj = block[blockKey];
            switch (blockKey) {
                case 'imoc':
                    return (
                        <GraphqlImoc
                            key={blockKey}
                            imocBlock={blockObj}
                            brand={brand}
                            samedayCutoff={samedayCutoff}
                            totalCount={totalCount}
                            ssrDeviceType={ssrDeviceType}
                            featureFlags={featureFlags}
                            setFacetsOptions={setFacetsOptions}
                            setFilterOptions={setFilterOptions}
                            presentation_family={presentation_family}
                            productFacets={productFacets}
                            imocHeightHandler={imocHeightHandler}
                        />
                    );
                case 'sub_navigation':
                    return (
                        <GraphqlSubnav key={blockKey} subnavBlock={blockObj} />
                    );
                default:
                    return null;
            }
        }) : null}
    </>
);

GraphqlCatHeaderContainer.propTypes = {
    // categoryHeader: arrayOf(
    //     shape({
    //         imoc: object.isRequired,
    //         sub_navigation: object,
    //     }),
    // ).isRequired,
    samedayCutoff: object,
    categoryHeader: array.isRequired,
    brand: string.isRequired,
    totalCount: number.isRequired,
    ssrDeviceType: string.isRequired,
    featureFlags: object.isRequired,
    setFacetsOptions: func.isRequired,
    setFilterOptions: func.isRequired,
    imocHeightHandler: func,
    presentation_family: string.isRequired,
    productFacets: arrayOf(
        shape({
            name: string.isRequired,
            entries: arrayOf(
                shape({
                    name: string.isRequired,
                    value: string.isRequired,
                }),
            ).isRequired,
        }).isRequired,
    ).isRequired,
};

GraphqlCatHeaderContainer.defaultProps = {
    samedayCutoff: {},
    imocHeightHandler: null,
};

export default GraphqlCatHeaderContainer;
